var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"product-image-link",attrs:{"href":"#"}},[_c('img',{staticClass:"thumbnail-image",attrs:{"alt":_vm.product.title,"src":_vm.product.image_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }